import React from 'react'
import * as EmailValidator from 'email-validator'
import queryString from 'query-string'

import { QueryContext } from '../../contexts/queryContext'

const EMAIL_FORM_ID: number = 464505
const FORM_SUBSCRIBE_URL: string = `https://api.convertkit.com/v3/forms/${EMAIL_FORM_ID}/subscribe`
const TAG_SUBSCRIBE_URL: string = `https://cj9thcorxi.execute-api.us-east-1.amazonaws.com/prod/submit_elementor_form`
// const TAG_SUBSCRIBE_URL = `https://api.might-could.com/prod/submit_elementor_form`;
const REDIRECT_URL: string = 'https://might-could.com/welcome-to-might-could/'

const subcribeToForm = async (email: string, first_name: string) => {
  const subscribe_data = {
    api_key: process.env.REACT_APP_CK_API_KEY,
    email: email,
    first_name: first_name,
  }
  const url_data = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(subscribe_data),
  }
  return fetch(FORM_SUBSCRIBE_URL, url_data)
}

// query is a dictionary of items
const subscribeToTags = async (email: string, _query: object) => {
  const ACCEPTABLE_TAGS = [
    'source',
    'style',
    'optin',
    'email',
    'page_title',
    'post_title',
    'utm_campaign',
    'utm_adset',
    'utm_ad',
    'utm_source',
    'utm_medium',
    'utm_placement',
    'utm_site_source',
  ]
  let query = JSON.parse(JSON.stringify(_query)) // So that the global isn't modified
  query['email'] = email // Add email to the query
  query['optin'] = 'emails' // Add optin to the query
  query['page_title'] = 'Art Style Results' // Add optin to the query
  if ('src' in query) {
    query['source'] = query['src'] // reformat
    delete query['src']
  }
  const structured_query_params = Object.entries(query).reduce(
    (accu, [k, v]) => {
      if (ACCEPTABLE_TAGS.indexOf(k) !== -1) {
        return {
          ...accu,
          [`fields[${k}][id]`]: k,
          [`fields[${k}][value]`]: v,
        }
      } else {
        console.log(
          `Ignoring query param ${k} since it is not in acceptable_tags: ${ACCEPTABLE_TAGS}`,
        )
        return accu
      }
    },
    {},
  )
  const encoded_data = encode_dict(structured_query_params)
  const url_data = {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, // Must be this for CORS
    body: encoded_data,
  }
  return fetch(TAG_SUBSCRIBE_URL, url_data)
}

const redirect_to_success = (query: queryString.ParsedQuery<string>) => {
  const created_redirect_url = queryString.stringifyUrl({
    url: REDIRECT_URL,
    query: query,
  })
  window.location.replace(created_redirect_url)
}

const encode_dict = (data: object) => {
  let entries = Object.entries(data)
  let encoded_entries = entries.map(
    ([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`,
  )
  let encoded_query = encoded_entries.join('&')
  return encoded_query
}

type FormOptinProps = {
  buttonText: string
}

const FormOptin: React.FC<FormOptinProps> = ({ buttonText }) => {
  // useScript('https://www.pineapplepodcasting.com/forms/2147700025/embed.js')

  return (
    <>
      <link
        rel='stylesheet'
        media='all'
        href='https://kajabi-app-assets.kajabi-cdn.com/assets/form_embed-ecdf08b1749d79682c2ab0463956d0c0ab955b29591a56ed173594b870d4dfb7.css'
      />
      <script src='https://kajabi-app-assets.kajabi-cdn.com/assets/form_embed-fd7a5360fe56f0a332f934492d89f18c2202d65871804504adca6fd4b6e78ceb.js'></script>
      <div id='kajabi-form' className='kajabi-form--inline'>
        <form
          data-parsley-validate='true'
          data-kjb-disable-on-submit='true'
          action='https://www.pineapplepodcasting.com/forms/2147700025/form_submissions'
          acceptCharset='UTF-8'
          method='post'>
          <input name='utf8' type='hidden' value='&#x2713;' />
          <input
            type='hidden'
            name='authenticity_token'
            value='m1p0v2CTMgtSJu9vI4msA8lR12SBlpRlQBnMrU+sJHQh5l8/5oC/KCklZk75KDaZt13tQ6jHl/fmESgJhh1YeQ=='
          />
          <div className='kajabi-form__content'>
            <div className='kajabi-form__title'></div>

            <fieldset>
              <div className='text-field kajabi-form__form-item'>
                <input
                  type='text'
                  name='form_submission[name]'
                  id='form_submission_name'
                  required={true}
                  placeholder='First Name'
                />
              </div>
              <div className='email-field kajabi-form__form-item'>
                <input
                  required={true}
                  placeholder='Email Address'
                  data-parsley-remote='true'
                  data-parsley-remote-validator='kjb_email_validator'
                  type='email'
                  name='form_submission[email]'
                  id='form_submission_email'
                />
              </div>
              <button
                className='kajabi-form__btn kajabi-form__btn--block-mobile'
                type='submit'>
                Grab Free Workshop
              </button>
            </fieldset>

            <br />
            <div className='kajabi-form__subtitle'>
              <p style={{ textAlign: 'center' }}>
                We hate spam and never send it.
              </p>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}

export default FormOptin
